import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AddEditAirportPage from './components/admin/AddEditAirportPage';
import AddFlightPage from './components/admin/AddFlightPage';
import AdminBookingDetailsPage from './components/admin/AdminBookingDetailsPage';
import AdminDashboardPage from './components/admin/AdminDashboardPage';
import AdminFlightDetailsPage from './components/admin/AdminFlightDetailsPage';
import SpecialRegistration from './components/admin/SpecialRegistration';
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/registerPage';
import Footer from './components/common/Footer';
import Navbar from './components/common/Navbar';
import FindFlightsPage from './components/pages/FindFlightsPage';
import HomePage from './components/pages/HomePage';
import BookingDetailsPage from './components/profile/BookingDetailsPage';
import BookingPage from './components/profile/BookingPage';
import ProfilePage from './components/profile/ProfilePage';
import UpdateProfilePage from './components/profile/UpdateProfilePage';
import RouteGuard from './services/RouteGuard';

function App() {
  return (
    <div className="app-shell">
      <BrowserRouter>
        <Navbar />

        <div className="content">
          <Routes>
            {/* Auth Pages */}
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Public Pages */}
            <Route path="/home" element={<HomePage />} />
            <Route path="/flights" element={<FindFlightsPage />} />

            {/* Customer Pages */}
            <Route
              path="/profile"
              element={<RouteGuard allowedRoles={['CUSTOMER']} element={<ProfilePage />} />}
            />
            <Route
              path="/update-profile"
              element={<RouteGuard allowedRoles={['CUSTOMER']} element={<UpdateProfilePage />} />}
            />
            <Route
              path="/book-flight/:id"
              element={
                <RouteGuard
                  allowedRoles={['CUSTOMER', 'ADMIN', 'PILOT']}
                  element={<BookingPage />}
                />
              }
            />
            <Route
              path="/booking/:id"
              element={
                <RouteGuard
                  allowedRoles={['CUSTOMER', 'ADMIN', 'PILOT']}
                  element={<BookingDetailsPage />}
                />
              }
            />

            {/* ADMIN & PILOTS PAGE */}
            <Route
              path="/admin"
              element={
                <RouteGuard allowedRoles={['ADMIN', 'PILOT']} element={<AdminDashboardPage />} />
              }
            />
            <Route
              path="/admin/boooking/:id"
              element={
                <RouteGuard
                  allowedRoles={['ADMIN', 'PILOT']}
                  element={<AdminBookingDetailsPage />}
                />
              }
            />
            <Route
              path="/admin/flights/:id"
              element={<RouteGuard allowedRoles={['PILOT']} element={<AdminFlightDetailsPage />} />}
            />

            <Route
              path="/add-airport"
              element={<RouteGuard allowedRoles={['ADMIN']} element={<AddEditAirportPage />} />}
            />
            <Route
              path="/edit-airport/:id"
              element={<RouteGuard allowedRoles={['ADMIN']} element={<AddEditAirportPage />} />}
            />
            <Route
              path="/add-flight"
              element={<RouteGuard allowedRoles={['ADMIN', 'PILOT']} element={<AddFlightPage />} />}
            />
            <Route
              path="/special-register"
              element={<RouteGuard allowedRoles={['ADMIN']} element={<SpecialRegistration />} />}
            />

            {/* Redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/home" />}></Route>
          </Routes>
        </div>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
